import { WorksheetSchemaListItem } from '../../../../../types/custom-worksheet-v2';
import { getFieldCount, sortByOrder } from '../../store/utils';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { removeInstance } from '../../store/slice';
import FlashBackground from '../FlashBackground';
import Property from '../Property';
import PropertyHeader from '../PropertyHeader';
import DeleteListItemConfirmation from './DeleteListItemConfirmation';
import { selectShowHidden } from '../../store/selectors';

type ListItemProps = {
    listItem: WorksheetSchemaListItem;
};

function ListItem({ listItem }: ListItemProps): JSX.Element {
    const dispatch = useDispatch();
    const showHiddenFields = useSelector(selectShowHidden);
    const { completed } = getFieldCount(listItem, showHiddenFields);

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    function handleRemove(): void {
        if (completed !== 0) {
            setShowDeleteConfirmation(true);
            return;
        }
        dispatch(removeInstance(listItem.id));
    }

    return (
        <div id={listItem.id} className="scroll-mt-8 h-fit w-full relative border-t border-gray-200 pt-4">
            {showDeleteConfirmation && (
                <DeleteListItemConfirmation id={listItem.id} name={listItem.name} onClose={(): void => setShowDeleteConfirmation(false)} />
            )}
            <FlashBackground id={listItem.id} />
            <PropertyHeader property={listItem} headingSize="xl" onRemove={handleRemove} />
            {/* Show section container when list item is expanded */}
            {Object.keys(listItem.properties).length > 0 && (
                <div className="pl-4 flex flex-col gap-4 mt-4">
                    {sortByOrder(listItem.properties).map((value) => {
                        return <Property key={value.id} value={value} />;
                    })}
                </div>
            )}
        </div>
    );
}

export default ListItem;
